import React from 'react';
import Icon from '../../../components/AppIcon';

const ApproachSection = () => {
  const principles = [
    {
      icon: "Activity",
      title: "Data-Driven Insights",
      description: "Every project starts with scientific analysis and observation—whether it's UAV-based crop health assessment or geomagnetic data modeling."
    },
    {
      icon: "BookOpen",
      title: "Accessible STEM Education",
      description: "I break down complex space and tech concepts into engaging learning experiences that spark curiosity in young minds."
    },
    {
      icon: "Users",
      title: "Collaborative Innovation",
      description: "From working with ISRO and NASA tutors to guiding school outreach, I believe knowledge grows when it's shared openly."
    },
    {
      icon: "RefreshCw",
      title: "Iterative Learning & Impact",
      description: "Learning never stops—I constantly refine my skills, tools, and methods through experimentation, feedback, and real-world applications."
    }
  ];


  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold text-text-primary mb-6">
            My Research & Learning Philosophy
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            I've always believed that true innovation happens when curiosity meets purpose. My approach blends scientific reasoning, real-world applications, and inclusive learning—building meaningful solutions for Earth and beyond.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {principles.map((principle, index) => (
            <div key={index} className="group">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center group-hover:bg-accent/20 transition-smooth">
                    <Icon 
                      name={principle.icon} 
                      size={24} 
                      className="text-accent"
                    />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-xl font-semibold text-text-primary mb-3">
                    {principle.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Philosophy Quote */}
        <div className="mt-16 text-center">
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 lg:p-12 max-w-4xl mx-auto border border-white/10 shadow-2xl">
            <Icon name="Quote" size={32} className="text-accent mx-auto mb-6" />
            <blockquote className="text-xl lg:text-2xl font-medium text-text-primary mb-6 leading-relaxed">
              “When science becomes relatable, learning becomes unstoppable.”
            </blockquote>
            <cite className="text-text-secondary font-medium">— My Research & Learning Philosophy</cite>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;